const CONVERSION_RATE_KEY = 'CONVERSION_RATES';
const SUPPORTED_CURRENCIES_KEY = 'SUPPORTED_CURRENCIES';

function setConversionRates(conversionRates) {
    window.localStorage.setItem(CONVERSION_RATE_KEY, JSON.stringify(conversionRates));
}

function getConversionRates() {
    const data = window.localStorage.getItem(CONVERSION_RATE_KEY);
    return JSON.parse(data);
}

function setSupportedCurrencies(supportedCurrencies) {
    window.localStorage.setItem(SUPPORTED_CURRENCIES_KEY, JSON.stringify(supportedCurrencies));
}

function getSupportedCurrencies() {
    const data = window.localStorage.getItem(SUPPORTED_CURRENCIES_KEY);
    return JSON.parse(data);
}

function clearConversionRates() {
    window.localStorage.removeItem(CONVERSION_RATE_KEY);
}

function clearSupportedCurrencies() {
    window.localStorage.removeItem(SUPPORTED_CURRENCIES_KEY);
}

export {
    clearConversionRates,
    clearSupportedCurrencies,
    getConversionRates,
    getSupportedCurrencies,
    setConversionRates,
    setSupportedCurrencies,
};

export default {
    getConversionRates,
    setConversionRates,
    getSupportedCurrencies,
    setSupportedCurrencies,
    clearConversionRates,
    clearSupportedCurrencies,
};
